// const BaseUrl = "http://localhost:9000/"

const BaseUrl = "https://api.dev.theflexmanager.com/";

export default BaseUrl;
